/** Keep provenance attached to one selected member/patient pair. The server verifies the hint. */
export const resolveMemberDetailSelection = ( routeState, restored = {} ) => {
    const selection = null == routeState ? restored : routeState;
    const { memberId, patientId } = selection;
    const sameIdentity = memberId === restored.memberId && patientId === restored.patientId;
    const liveFallback = Object.prototype.hasOwnProperty.call( selection, 'liveFallback' )
        ? true === selection.liveFallback
        : sameIdentity && true === restored.liveFallback;

    return { memberId, patientId, liveFallback };
};

// Key both identities so copied/sorted rows retain provenance without trusting another patient's ID.
export const getMemberSearchSelectionKey = item => JSON.stringify( [
    item && item.id,
    item && item.values && item.values.patientId
] );
